// Règles PURES d'activation des boutons ERA / 3310 de l'écran AnalyseCspe.
// Un PDL exonéré (art. L312-31 CIBS, E04) n'a besoin ni de liasse, ni de TIC-VA, ni
// d'électro-intensité (décision D3, plan 2026-10-01). Un PDL sans exonération garde
// exactement les règles historiques.
// Un PDL chargé avant la migration 029 n'a pas la colonne exoneration_motif : il est
// traité comme non exonéré, l'écran se comporte alors comme avant.

export function estPdlExonere(pdl) {
  return !!pdl?.exoneration_motif;
}

// Vrai si la liste est NON VIDE et que tous ses PDL sont exonérés : la liasse fiscale
// n'est alors pas requise pour le 3310 (le backend applique la même règle).
export function tousPdlsExoneres(pdls) {
  return Array.isArray(pdls) && pdls.length > 0 && pdls.every(estPdlExonere);
}

// Bandeau « étapes 1 et 2 à compléter » de l'étape ERA : masqué seulement quand liasse et
// TIC-VA sont inutiles, c.-à-d. quand tous les PDL AVEC DONNÉES de l'année sont exonérés —
// même liste que la règle 3310 (une seule source de vérité).
export function afficherBandeauPrerequisEra({ liasseValidee, ticVaGenere, pdlsAvecData }) {
  if (liasseValidee && ticVaGenere) return false;
  return !tousPdlsExoneres(pdlsAvecData);
}

export function peutGenererEra({ pdl, aDesDonnees, enCours, liasseValidee, ticVaGenere, intensiteInsuffisante }) {
  if (!aDesDonnees || enCours) return false;
  if (estPdlExonere(pdl)) return true;
  return !!liasseValidee && !!ticVaGenere && !intensiteInsuffisante;
}

export function peutGenerer3310({ pdlsAvecData, tousEraGeneres, enCours, dejaGenere, intensiteInsuffisante }) {
  if (enCours || dejaGenere || !tousEraGeneres) return false;
  return !intensiteInsuffisante || tousPdlsExoneres(pdlsAvecData);
}

const fmtDateFr = (iso) => (iso ? `${iso.slice(8, 10)}/${iso.slice(5, 7)}/${iso.slice(0, 4)}` : '');
const fmtPct = (p) => String(Number(p)).replace('.', ',');

export function libelleExoneration(pdl) {
  if (!estPdlExonere(pdl)) return null;
  const parts = [`${pdl.exoneration_motif} · ${fmtPct(pdl.exoneration_pourcentage)} %`];
  if (pdl.exoneration_date_debut) parts.push(`dès ${fmtDateFr(pdl.exoneration_date_debut)}`);
  return parts.join(' · ');
}

// Étape 6 « Combinaison des CERFAs » : documents de l'exercice à fusionner et pièces manquantes.
// ERA (au moins un) et 3310-TIC sont toujours exigés. La TIC-VA l'est aussi, sauf si tous les
// PDL avec données de l'année sont exonérés : le backend génère alors ERA et 3310 sans TIC-VA.
// L'ordre d'origine des chemins est conservé.
const TYPES_A_FUSIONNER = ['CERFA_ERA', 'CERFA_TIC_VA', 'CERFA_3310_TIC'];

export function documentsAFusionner({ cerfas, exerciceEndDate, pdlsAvecData }) {
  const duDossier = (Array.isArray(cerfas) ? cerfas : []).filter(
    (c) => c?.exercice_end_date === exerciceEndDate && TYPES_A_FUSIONNER.includes(c.document_type),
  );
  const present = (type) => duDossier.some((c) => c.document_type === type);
  const manquants = [];
  if (!present('CERFA_ERA')) manquants.push('ERA');
  if (!present('CERFA_TIC_VA') && !tousPdlsExoneres(pdlsAvecData)) manquants.push('TIC-VA');
  if (!present('CERFA_3310_TIC')) manquants.push('3310-TIC');
  return { chemins: duDossier.map((c) => c.storage_path), manquants };
}
